module.exports = __webpack_public_path__ + "static/media/lojaDeConveniencia.9e570c5f.svg";